<template>
  <b-input
    v-model="credentials.code"
    :error-messages="getErrorMessages(v$.code)"
    label="Код журналу"
    placeholder="Введіть код"
    @blur="v$.code.$touch()" />
  <b-input
    v-model="credentials.name"
    :error-messages="getErrorMessages(v$.name)"
    label="Назва журналу"
    placeholder="Введіть назву"
    @blur="v$.name.$touch()" />
</template>
<script>
import { reactive } from 'vue'
import { required, useVuelidate } from '@/plugins'
import { getErrorMessages } from '@/utils/helpers'
import { registrationJournalCreate } from '@/requests/registrationJournal'

export default {
  name: 'RegistrationJournal',
  props: {
    dialog: { type: Object, required: true },
  },
  methods: { getErrorMessages },
  setup() {
    const credentials = reactive({
      code: null,
      name: null,
    })

    const v$ = useVuelidate(
      { code: { required }, name: { required } },
      credentials
    )

    const submit = () => {
      return registrationJournalCreate(credentials).then(res => {
        return res
      })
    }

    return { v$, submit, credentials, validationScope: 'registrationJournal' }
  },
}
</script>
